export const PATHS = Object.freeze({
    ROOT: '/',
    // Non-admin app routes
    WORKKARDS: '/workkards',
    WORKKARD_LIST_LEGACY: '/WorkkardList',
    WORKKARD_CREATE: '/workkards/create',
    WORKKARD_EDIT: '/workkards/edit/:id',
    POLICIES: '/policies',
    ACTIVITIES: '/activities',
    ACTIVITY_CREATE: '/workkards/:workkardId/activity/create',
    ACTIVITY_EDIT: '/workkards/:workkardId/activity/edit/:actId',
    REQUESTS: '/requests',
    DIARIES: '/diaries',
    TDO: '/tdo',
    WORKKARD_DETAIL: '/getclmdetail',
    PRINT_WORKKARD_DETAIL: '/printworkkarddetail',
    ACTIVITY_DETAIL: '/gad',
    INBOX: '/inbox',
    BULK_INBOX: '/bulkinbox',
    VIEWS: '/view',
    DESKS: '/mercury',
    REVIEW_CENTER: '/mrc',
    APPROVALS: '/financial?ct=approvals',
    LETTERS: '/letters',
    LOGOUT: '/logout',
    UNAUTH_LOGOUT: '/unauthlgout',
    SIGNED_OUT: '/signedout',
    // Admin routes
    ORG_PROFILE: '/orgprofile',
    ORG_ACCESS: '/orgaccess',
    USERS: '/users',
    MANAGE_COMM: '/managecomm',
    SETTINGS: '/settings',
    PARTIES: '/parties',
    RELATIONSHIPS: '/relationships',
    RULE_ENGINE: '/ruleengine',
    INBOX_ADMIN: '/inboxadmin',
    MERCURY_ADMIN: '/mercuryadmin',
    LETTER_ADMIN: '/letteradmin',
    MANAGE_WORKLOAD: '/users/manageworkload/:userId',
    USER_ADD: '/users/add',
    USER_EDIT: '/users/edit/:userId',
    USER_PROFILE: '/user-profile/:encrypted',
    AGREEMENT: 'agreement',
    Privacy_Policy: 'privacypolicy'
});

export const ADMIN_PATHS = Object.freeze([
    PATHS.ORG_PROFILE,
    PATHS.ORG_ACCESS,
    PATHS.USERS,
    PATHS.MANAGE_COMM,
    PATHS.SETTINGS,
    PATHS.PARTIES,
    PATHS.RELATIONSHIPS,
    PATHS.RULE_ENGINE,
    PATHS.INBOX_ADMIN,
    PATHS.MERCURY_ADMIN,
    PATHS.LETTER_ADMIN,
]);
